// extracted by mini-css-extract-plugin
export default {"page":"YW-z","cartModal":"ZW-z","checkout":"_W-z","placeholder":"aX-z","account":"bX-z"};